import { createTheme } from "@mui/material/styles";

export const COLORS = {
  ink: "#16233A",
  inkSoft: "#4C5A6E",
  paper: "#EEF0E9",
  paperCard: "#FBFBF8",
  line: "#D8DACF",
  brass: "#B9812E",
  brassSoft: "#F1E3C9",
  green: "#2E6B4F",
  greenSoft: "#DCEAE0",
  rust: "#A8402C",
  rustSoft: "#F3DCD6",
};

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: COLORS.ink, contrastText: COLORS.brassSoft },
    secondary: { main: COLORS.brass },
    error: { main: COLORS.rust },
    success: { main: COLORS.green },
    background: { default: COLORS.paper, paper: COLORS.paperCard },
    text: { primary: COLORS.ink, secondary: COLORS.inkSoft },
  },
  typography: {
    fontFamily: "'IBM Plex Sans', sans-serif",
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: { root: { textTransform: "none", fontWeight: 600 } },
    },
    MuiPaper: {
      styleOverrides: { root: { border: `1px solid ${COLORS.line}` } },
    },
    MuiChip: {
      styleOverrides: { root: { fontFamily: "'IBM Plex Mono', monospace" } },
    },
  },
});

export default theme;
